module.exports = __webpack_public_path__ + "img/selected2-min.1d3f99c4.png";